module.exports = __webpack_public_path__ + "static/media/login-background1.9e8142a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background1.png
// module id = 1212
// module chunks = 110